export const APP_ROUTES = {
  search: '/search'
} as const;
